import React from 'react';

export default props => (
  <svg
    width="120px"
    height="60px"
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="30 0 367.97 153.61"
  >
    <defs />
    <title>Sift_RBG_ColorBlack</title>
    <g id="Oval-1-Copy-42">
      <circle fill="#EF5296" cx="44.89" cy="69.32" r="14.03" />
    </g>
    <g id="Oval-1-Copy-43">
      <circle fill="#F27176" cx="83.77" cy="69.32" r="14.03" />
    </g>
    <g id="Oval-1-Copy-44">
      <circle fill="#F78D2C" cx="122.59" cy="69.32" r="14.03" />
    </g>
    <g id="Oval-1-Copy-45">
      <circle fill="#F4A81D" cx="83.77" cy="107.28" r="14.03" />
    </g>
    <path
      className="cls-5"
      d="M150.05,100.38l13.52-7.91a.86.86,0,0,1,1.22.42c3.28,7.74,9.45,12.69,20.1,12.69s14.24-4.45,14.24-9.41c0-6.61-6-9.15-19.2-13-13.6-3.94-26.82-9.66-26.82-26.57s14-26.45,29.24-26.45c14.34,0,25.37,7.22,31.43,19.24a.87.87,0,0,1-.34,1.13l-13.26,7.66a.86.86,0,0,1-1.19-.37c-3.19-6.29-8-10.62-16.64-10.62-7.37,0-11.7,3.82-11.7,8.9,0,5.47,3.44,8.39,16.91,12.46,14.12,4.45,29.12,9.16,29.12,27.34,0,16.65-13.35,26.82-32.3,26.82-17.86,0-29.71-8.47-34.7-21.31A.87.87,0,0,1,150.05,100.38Z"
    />
    <path
      fill="#212121"
      d="M225.8,33.75a.8.8,0,0,1,.17-.15c8.06-5.62,16.71.45,16.71,8a10.17,10.17,0,0,1-10.17,10C224.51,51.62,218.41,41.8,225.8,33.75Zm-.57,25.49h14.69a.87.87,0,0,1,.86.86v60a.86.86,0,0,1-.86.85H225.23a.86.86,0,0,1-.86-.85v-60A.87.87,0,0,1,225.23,59.24Z"
    />
    <path
      fill="#212121"
      d="M275.13,56.76v2.48h12.63a.86.86,0,0,1,.85.86V72.17a.85.85,0,0,1-.85.85H276a.87.87,0,0,0-.86.86v46.23a.85.85,0,0,1-.85.85H259.59a.85.85,0,0,1-.86-.85V73.88a.86.86,0,0,0-.85-.86h-7.45a.85.85,0,0,1-.85-.85V60.1a.86.86,0,0,1,.85-.86h8.3V56.76c0-17.31,9.4-27.57,29.06-26.62a.86.86,0,0,1,.82.86V45a.85.85,0,0,1-.91.85C279.74,45.52,275.13,48.42,275.13,56.76Z"
    />
    <path
      fill="#212121"
      d="M323.59,73a.86.86,0,0,0-.85.86V99.6c0,6.65,4.64,7,13.46,6.54a.86.86,0,0,1,.91.85v13.2a.87.87,0,0,1-.78.86c-22.41,2.3-30-4.47-30-21.45V73.88a.86.86,0,0,0-.85-.86h-9.36a.85.85,0,0,1-.85-.85V60.1a.86.86,0,0,1,.85-.86h9.36a.85.85,0,0,0,.85-.85v-11a.86.86,0,0,1,.56-.81l14.7-5.33a.85.85,0,0,1,1.14.81V58.39a.85.85,0,0,0,.85.85h12.66a.86.86,0,0,1,.86.86V72.17a.85.85,0,0,1-.86.85Z"
    />
  </svg>
);
